import styled from 'styled-components';
import {grayLighter} from 'styles/constants';

export default styled.hr`
	background: ${grayLighter};
	border: none;
	height: 1px;
	margin: 0px;
`;
